<template>
  <div>
    <div class="legend">
      <p>К - курьер</p>
      <p>СК - старший курьер</p>
      <p>М - менеджер</p>
      <p>ПМ - помощьник менеджера</p>
      <p>S - контролер</p>
    </div>
    <multiselect
      name="user_role"
      v-model="selectedUsers"
      :options="users"
      @input="addUser"
      placeholder="Выберите пользователя"
      track-by="name"
      label="name"
      :showLabels="false"
      :searchable="true"
      :multiple="true">
      <template slot="noResult">Пользователь не найден</template>
    </multiselect>
    <div>
      <textarea class="form-control mt-1" rows="2" placeholder="Тест сообщения" v-model="text"></textarea>
    </div>
    <div class="text-right">
      <LoadingButton
        title="Отправить"
        className="btn btn-outline-info mt-1"
        :onClick="sendMessage"
        :loading="loading"
        :color="$constants.SUCCESS_COLOR"
      />
    </div>
  </div>
</template>

<script>

import api from '@/api'
import Multiselect from 'vue-multiselect'
import LoadingButton from '@/components/buttons/LoadingButton'

export default {
  components: {
    Multiselect,
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      selectedUsers: [],
      users: [],
      text: null,
    }
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    async getUsers() {
      const {data} = await api.index('users/active')
      if (data.success) {
        this.users = data.users.reduce((acc, u) => {
          const telegram = u.details.find((d) => d.alias === 'telegram_chat_data' && d.details && d.details.chat_id);
          if (telegram) {
            const division = u.details.find((d) => d.alias === 'division_id');
            let divisionName;
            if (division && division.details) {
              divisionName = this.$AllDivisions[division.details].title;
            }
            let profileName;
            u.roles.forEach((r) => {
              switch (r.name) {
                case 'managerAssist':
                  profileName = 'ПМ';
                  break;
                case 'supervisor':
                  profileName = 'S';
                  break;
                case 'manager':
                  profileName = 'М';
                  break;
                case 'chiefRunner':
                  profileName = 'СК';
                  break;
                case 'runner':
                  if (!profileName) {
                    profileName = 'К';
                  }
                  break;
                default:
                  break;
              }
            })
            acc.push({
              id: u.id,
              name: (divisionName || '') + '(' + profileName + ') ' + u.name
            })
          }
          return acc;
        }, []);
      }
    },
    addUser(e) {
      console.log(e);
    },
    async sendMessage() {
      if (!this.text) {
        toastr['warning']('Не указано сообщение для отправки');
        return;
      }
      if (!this.selectedUsers || !this.selectedUsers.length) {
        toastr['warning']('Не выбраны получатели');
        return;
      }
      this.loading = true;
      const {data} = await api.post('/telegram/sendToUsers', {
        users: this.selectedUsers.map((u) => u.id),
        message: this.text,
      })
      if (data.success) {
        if (data.errors && data.errors.length) {
          toastr['warning'](data.errors.join(', '));
        } else {
          toastr['success'](data.message || 'Отправлено');
        }
      } else {
        toastr['warning'](data.message || 'Ошибка отправки');
      }
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.legend p {
  margin-bottom: 0;
}

.legend {
  font-size: 14px;
}
</style>
